import Price from "./Price";
export const UNLIMITED = 999999;
export default interface Plan {
  id: number;
  externalName: string;
  internalName: string;
  price: Price;
  includedQtyGuiSendPerMonth: number;
  includedArchiveMonths: number;
  includedEmailSupportMonth: number;
  includedLogoProfile: boolean;
  includedQtyApiSendPerMonth: number;
  includedUsers: number;
  startDate: Date | null;
  endDate: Date | null;
}
